import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get_DashboardData } from '../../../Service/Dashboard/dashboardService'


export const getDashboardData = createAsyncThunk("getdashboard", async (data) => {
    try {
        const res = await get_DashboardData(data);
        return await res;
    } catch (err) {
        return err;
    }
});


const dashboardSlice = createSlice({
    name: "dashboardSlice",
    initialState: {
        isLoading: false,
        isError: false,
        getdashboard: [],
    },

    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getDashboardData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getdashboard = action.payload;
            })
            .addCase(getDashboardData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },
});

export default dashboardSlice;
